<style lang="scss" scoped>

    #myParametricSearchContent {
        margin-top: 30px;
    }

    @media only screen and (min-width: 1200px) {
        .container {
            margin: 0 60px;
            width: auto;
        }
    }

</style>

<template>
    <div>
        <top-bar active-item="parametric-search"/>
        <div class="container">
            <div id="myParametricSearchContent" class="row">
                <router-view></router-view>
                <router-view name="driver"></router-view>
                <router-view name="compare"></router-view>
                <router-view name="demo"></router-view>
            </div>
        </div>
    </div>
</template>

<script>
    import TopBar from "../../components/TopBar";

    export default {
        name: "MyParametricSearch",
        components: {
            TopBar
        }
    }
</script>
